module.exports = __webpack_public_path__ + "img/right-icon.55dda488.png";